import { render } from "./SingleGame.vue?vue&type=template&id=6f2a6372&scoped=true"
import script from "./SingleGame.vue?vue&type=script&lang=js"
export * from "./SingleGame.vue?vue&type=script&lang=js"

import "./SingleGame.vue?vue&type=style&index=0&id=6f2a6372&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2a6372"]])

export default __exports__